import { DocumentModal, InquiryModal } from '@/utils/enums';
import { CategoryModal } from '@/features/categories/utils/enums';
import { Tooltip } from 'antd';

export const getDocumentMenu = (
  t: any,
  setOpenModal: any,
  node: any,
  setCurrentNode: any,
  onClose?: () => void,
  setNodeToDelete?: any,
  setNodeToEdit?: any,
  setNodeToMove?: any,
  canEditDefault?: boolean,
) => {
  const handleClick = (e: React.MouseEvent, modalType: DocumentModal) => {
    e.stopPropagation();
    if (modalType === DocumentModal.DELETE) {
      setNodeToDelete?.(node);
    } else if (modalType === DocumentModal.EDIT) {
      setNodeToEdit?.(node);
    } else if (modalType === DocumentModal.MOVE) {
      setNodeToMove?.(node);
    } else {
      setCurrentNode(node);
    }
    setOpenModal(modalType);
    onClose?.();
  };

  const isDefaultRestricted = node?.default && !node?.isLeaf && !canEditDefault;
  const restrictedTooltip = t('home.documents.table.actions.defaultFolderRestricted', 'Only Rakuyaku admins can modify default folders');

  return {
    items: [
      {
        key: DocumentModal.EDIT,
        disabled: isDefaultRestricted,
        label: isDefaultRestricted ? (
          <Tooltip title={restrictedTooltip}>
            <span>{t('home.documents.table.actions.edit')}</span>
          </Tooltip>
        ) : (
          <a onClick={e => handleClick(e, DocumentModal.EDIT)}>
            {t('home.documents.table.actions.edit')}
          </a>
        ),
      },
      {
        key: DocumentModal.MOVE,
        disabled: isDefaultRestricted,
        label: isDefaultRestricted ? (
          <Tooltip title={restrictedTooltip}>
            <span>{t('home.documents.table.actions.move')}</span>
          </Tooltip>
        ) : (
          <a onClick={e => handleClick(e, DocumentModal.MOVE)}>
            {t('home.documents.table.actions.move')}
          </a>
        ),
      },
      {
        key: DocumentModal.DELETE,
        disabled: isDefaultRestricted,
        label: isDefaultRestricted ? (
          <Tooltip title={restrictedTooltip}>
            <span>{t('home.documents.table.actions.delete')}</span>
          </Tooltip>
        ) : (
          <a onClick={e => handleClick(e, DocumentModal.DELETE)}>
            {t('home.documents.table.actions.delete')}
          </a>
        ),
      },
    ],
  };
};

export const getCategoryMenu = (t: any, setOpenModal: any) => {
  return {
    items: [
      {
        key: CategoryModal.EDIT,
        label: (
          <a
            onClick={() => {
              setOpenModal(CategoryModal.EDIT);
            }}
          >
            {t('home.categories.table.actions.edit')}
          </a>
        ),
      },
      {
        key: CategoryModal.DELETE,
        label: (
          <a
            onClick={() => {
              setOpenModal(CategoryModal.DELETE);
            }}
          >
            {t('home.categories.table.actions.delete')}
          </a>
        ),
      },
    ],
  };
};

export const getInquiryMenu = (t: any, setOpenModal: any) => {
  return {
    items: [
      {
        key: '1',
        label: (
          <a
            onClick={() => {
              setOpenModal(InquiryModal.EDIT);
            }}
          >
            {t('home.chat.actions.edit')}
          </a>
        ),
      },
      {
        key: '2',
        label: (
          <a
            onClick={e => {
              e.stopPropagation();
              setOpenModal(InquiryModal.DELETE);
            }}
          >
            {t('home.chat.actions.delete')}
          </a>
        ),
      },
    ],
  };
};
